import { useQuery } from '@tanstack/vue-query';

// List of postgres developer IDs the current user is watching. Drives the
// "Watching" filter chip + the gold accent on /developers cards + the
// Watch/Unwatch button state on /developers/<slug>.
export const useWatchedDevelopersQuery = () => {
  const authStore = useAuthStore();
  return useQuery({
    queryKey: ['developers', 'watched'],
    queryFn: () =>
      $fetch<{ success: boolean; data: number[] }>('/api/agents/me/watched-developers', {
        headers: { Authorization: `Bearer ${authStore.token}` },
      }),
    enabled: computed(() => !!authStore.token),
    select: (res) => res?.data ?? [],
    staleTime: 60_000,
    retry: false,
    throwOnError: false,
  });
};
